var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.7 37.8",
    style: {
      enableBackground: "new 0 0 127.7 37.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DD6B7C;}\n\t.st1{fill:#DD4C6A;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#4E1B3D;}\n\t.st4{fill:url(#SVGID_00000127749866487634799360000017246844637418900923_);}\n\t.st5{fill:url(#SVGID_00000179629852630653910180000016579737990710003645_);}\n\t.st6{fill:url(#SVGID_00000081646377016880856260000003869502782145402008_);}\n\t.st7{opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:url(#SVGID_00000175323792324429743990000009815678226589015980_);}\n\t.st10{fill:url(#SVGID_00000103944113376241637080000011962469618813198265_);}\n\t.st11{fill:url(#SVGID_00000095327003483055464390000011143096118831215783_);}\n\t.st12{fill:url(#SVGID_00000047771511722640110220000006186100633818567553_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.6,37.4c0,0,16,3.2,26.8-7.8l-0.8-4C123.6,25.6,114.9,35.8,97.6,37.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,18.9c0,0,2.8-15.5,16.1-18.5s20.5,10,20.5,10S103.3-7.1,88.6,18.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.5847,
    y1: 0.2642,
    x2: 106.5847,
    y2: 35.0019,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.5,30.9c1.3,6.3,10.8,8.3,21.7,5.6c15.7-4,16.4-15.7,14-22.1S115,0.2,101.9,4 C88.7,7.8,86.7,22.3,88.5,30.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.2,29c0,0-2-16.1,12.5-22.5c12.8-5.6,21.9,3.3,23.8,8.5c0,0,3.4-3.4,3.3-4.9c-0.3-5.7-8.8-10.5-21.3-8.6 C94.2,3.5,86.8,13.5,88.2,29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,29c0,0,0,4.6,0.7,6.3c0.6,1.7,9.2,2.2,9.2,2.2S89.1,36.9,88.2,29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037689577484187467190000017101784861658085026_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.8,
    y1: 3.59,
    x2: 103.8,
    y2: 27.5632,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A93749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#751540"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000037689577484187467190000017101784861658085026_)"
    },
    cx: 103.8,
    cy: 22.3,
    r: 12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126293680171267413070000009567271732107631034_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.8,
    y1: 4.29,
    x2: 103.8,
    y2: 26.8608,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE6E49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#751540"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000126293680171267413070000009567271732107631034_)"
    },
    cx: 103.8,
    cy: 22.3,
    r: 11.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039834705044678653810000013147000526005522067_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.8,
    y1: 8.2633,
    x2: 103.8,
    y2: 22.9083,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4625C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000039834705044678653810000013147000526005522067_)"
    },
    cx: 103.8,
    cy: 22.3,
    r: 7.3
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.2,29c0,0,1.2-13.9,14.1-18c14.6-4.6,22.2,4,22.2,4s-3.6-12.5-19.7-10.2S87.9,21.4,88.2,29z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.6,19.8c-0.7,0.6,2.6,0.8,5.1-0.2c2.2-0.9,3.3-2.3,3.1-2.6C121.7,16.8,116.5,17.2,113.6,19.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M111.7,20.4c-1-0.3-2.1,0.2-2.1,0.7s1.1,1.1,1.7,0.9C111.8,21.8,112.2,20.6,111.7,20.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.1,37.4c0,0-16,3.2-26.8-7.8l0.8-4C4.1,25.6,12.8,35.8,30.1,37.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.1,18.9c0,0-2.8-15.5-16.1-18.5c-13.4-2.9-20.5,10-20.5,10S24.5-7.1,39.1,18.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151539698135485651010000010127552810715870368_",
    gradientUnits: "userSpaceOnUse",
    x1: -808.8067,
    y1: 0.2642,
    x2: -808.8067,
    y2: 35.0019,
    gradientTransform: "matrix(-1 0 0 -1 -787.6862 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151539698135485651010000010127552810715870368_)"
    },
    d: "M39.2,30.9c-1.3,6.3-10.8,8.3-21.7,5.6 c-15.7-4-16.4-15.7-14-22.1C5.9,7.9,12.7,0.1,25.9,3.9S41,22.3,39.2,30.9z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.6,29c0,0,2-16.1-12.5-22.5C14.2,0.9,5.1,9.9,3.3,15c0,0-3.4-3.4-3.3-4.9C0.3,4.5,8.8-0.3,21.3,1.6 C33.6,3.5,41,13.5,39.6,29z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.6,29c0,0,0,4.6-0.7,6.3c-0.6,1.7-9.2,2.2-9.2,2.2S38.6,36.9,39.6,29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130637812273284380810000003481150234856236475_",
    gradientUnits: "userSpaceOnUse",
    x1: -811.5862,
    y1: 3.59,
    x2: -811.5862,
    y2: 27.5632,
    gradientTransform: "matrix(-1 0 0 -1 -787.6862 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A93749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#751540"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000130637812273284380810000003481150234856236475_)"
    },
    cx: 23.9,
    cy: 22.3,
    r: 12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051353530609167896320000009564600657194830468_",
    gradientUnits: "userSpaceOnUse",
    x1: -811.5862,
    y1: 4.29,
    x2: -811.5862,
    y2: 26.8608,
    gradientTransform: "matrix(-1 0 0 -1 -787.6862 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE6E49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#751540"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000051353530609167896320000009564600657194830468_)"
    },
    cx: 23.9,
    cy: 22.3,
    r: 11.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017517200193099361380000008738827187580624513_",
    gradientUnits: "userSpaceOnUse",
    x1: -811.5862,
    y1: 8.2633,
    x2: -811.5862,
    y2: 22.9083,
    gradientTransform: "matrix(-1 0 0 -1 -787.6862 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4625C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000017517200193099361380000008738827187580624513_)"
    },
    cx: 23.9,
    cy: 22.3,
    r: 7.3
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.6,29c0,0-1.2-13.9-14.1-18C10.9,6.4,3.3,15,3.3,15S6.8,2.6,23,4.8S39.8,21.4,39.6,29z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M14.1,19.8c0.7,0.6-2.6,0.8-5.1-0.2c-2.2-0.9-3.3-2.3-3.1-2.6C6.1,16.8,11.3,17.2,14.1,19.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16,20.4c1-0.3,2.1,0.2,2.1,0.7S17,22.2,16.4,22C15.9,21.8,15.5,20.6,16,20.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes5);
export default __webpack_public_path__ + "static/media/Eyes5.c510fd8866071a5827016ccee9e252b4.svg";
export { ForwardRef as ReactComponent };